import { AddFormButton } from "@components/buttons/AddFormPackageButton/AddFormPackageButton";
import { EFormStatus } from "src/enums/EFormStatus";
import { FormsWrapper } from "./FormsWrapper";
import { IFormData } from "../../../../types/formsTable/FormTable.interface";
import { IFormPackage } from "../../../../types/formAssignments/packages/IFormPackage";
import {
  IInOfficeEvent,
  IFormAssignmentForm,
} from "../../../../types/formAssignments/IInOfficeEvent";
import { useMemo } from "react";

interface FormSelectionAndViewProps {
  handleFormSelection: (form: IFormData) => void;
  handleDeleteForm: (formId: number) => void;
  handlePackageSelection: (formPackage: IFormPackage) => void;
  selectedEvent: IInOfficeEvent;
  incompleteForms: IFormAssignmentForm[];
}

export default function FormSelectionAndView({
  handleFormSelection,
  handleDeleteForm,
  handlePackageSelection,
  selectedEvent,
  incompleteForms,
}: FormSelectionAndViewProps) {
  const incompletePackageIds = useMemo(
    () =>
      incompleteForms
        .map((form) => form.packageId)
        .filter((id): id is string => Boolean(id)),
    [incompleteForms]
  );

  const completeForms = useMemo(() => {
    return (
      selectedEvent.formAssignment?.forms?.filter(
        (form) => form.status === EFormStatus.Submitted
      ) ?? []
    );
  }, [selectedEvent.formAssignment?.forms]);

  return (
    <>
      <AddFormButton
        handleFormSelection={handleFormSelection}
        handlePackageSelection={handlePackageSelection}
        assignedPackageIds={incompletePackageIds}
      />
      <FormsWrapper
        title="Incomplete Forms"
        forms={incompleteForms}
        onDeleteForm={handleDeleteForm}
      />
      <FormsWrapper title="Complete Forms" forms={completeForms} />
    </>
  );
}
